import PropTypes from 'prop-types';
import PlacesAutocomplete from 'react-places-autocomplete';
import {
  Box,
  TextField,
} from '@mui/material';

import { useStyles } from './style';

export const GooglePlaceSearch = ({ onBlur = () => { }, ...props }) => {
  const classes = useStyles();

  return (
    <PlacesAutocomplete
      {...props}
    >
      {({
        getInputProps, suggestions, getSuggestionItemProps, loading
      }) => (
        <Box className={classes.dropdownContainerWrapper}>
          <TextField
            {...getInputProps({
              placeholder: 'Search Address ...',
              className: 'inputFormTopMargin',
              onBlur: onBlur
            })}
          />
          <Box className={classes.dropdownContainer}>
            {loading && <Box>Loading...</Box>}
            {suggestions.map((suggestion) => {
              const className = suggestion.active
                ? classes.suggestionItemActive
                : classes.suggestionItem;
              return (
                <Box
                  {...getSuggestionItemProps(suggestion, {
                    className,
                  })}
                  key={suggestion.placeId}
                >
                  <Box component="span">{suggestion.description}</Box>
                </Box>
              );
            })}
          </Box>
        </Box>
      )}
    </PlacesAutocomplete>
  );
};

GooglePlaceSearch.propTypes = {
  onBlur: PropTypes.func
};

GooglePlaceSearch.defaultProps = {
  onBlur: () => { }
};
